<template>
  <div class="not-found d-flex align-items-center h-100">
    <NotFound />
  </div>
</template>

<script>
import NotFound from '@/components/NotFound.vue'

export default {
  components: {
    NotFound
  },
  mounted() {
    let page = document.getElementById('app')
    let footer = document.getElementsByClassName('footer')[0]
    let content = document.getElementsByClassName('not-found')[0]
    let navbar = document.getElementById('navbar')

    if( content && page && footer && navbar ) {
      content.style.padding = navbar.offsetHeight + 'px 0 0 0'
      content.style.height = (page.offsetHeight - footer.offsetHeight) + 'px'
    }
  },
}
</script>
